import { initEnv } from '@analytical-alley/ui/utils/env';

export const env = initEnv<ImportMetaEnv>(import.meta.env);
